exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-0fa91ab1]{font-size:20px}.apple-ic[data-v-0fa91ab1],.paypal-ic[data-v-0fa91ab1]{margin-top:-2px}.btn-gray .apple-ic[data-v-0fa91ab1],.btn-gray .paypal-ic[data-v-0fa91ab1]{opacity:.5}.btn-gray[data-v-0fa91ab1]{height:54px}", ""]);

// exports
